/* Strain Jams listening events for the product-page player (le-pdp-audio).
   Listens to the player's own <audio> elements; lab-article-audio.js (shared
   with the blog) is not touched. The tracker is le-jams-track.js. */
(function () {
  'use strict';
  if (window.__leJamsPdp) return;
  window.__leJamsPdp = 1;
  function init() {
    var T = window.LEJamsTrack;
    if (!T) return;
    var watched = {};
    document.querySelectorAll('.ar-audio--pdp[data-jam-song]').forEach(function (r) {
      var a = r.querySelector('audio');
      if (!a) return;
      var s = { h: r.dataset.jamSong, t: r.dataset.arTitle || '', s: r.dataset.jamStrain || '', g: r.dataset.jamGenre || '', d: +r.dataset.arDuration || 0 };
      if (!watched[s.h]) { watched[s.h] = 1; T.watchAddToCart(s.h); }
      var open = false;
      a.addEventListener('playing', function () { if (!open) { open = true; T.listenStart(s, { trigger: 'click', list: 'pdp', pos: 0 }); } });
      a.addEventListener('pause', function () { if (!a.ended) T.listenGap(); });
      a.addEventListener('seeking', function () { T.listenGap(); });
      a.addEventListener('timeupdate', function () { if (!a.paused) T.listenTick(a.currentTime, a.duration || s.d); });
      a.addEventListener('ended', function () { T.listenEnd('complete'); open = false; });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
